// extracted by mini-css-extract-plugin
export default {"container":"C3ZHQ5","accessibilityThemeContainer":"Rdawek","heading":"kqEant"};